export interface Profile {
  icon: string
  who: string
  situation: string
  benefit: string
}

/** "C'est pour vous si…" — avatar profiles of the product (not customer reviews). */
export const profiles: Profile[] = [
  {
    icon: '🩺',
    who: 'Infirmier ou infirmière en service',
    situation: 'Vous réalisez des ECG et surveillez des scopes, mais devant douze dérivations vous ne savez pas toujours par où commencer.',
    benefit: 'Une lecture dans le même ordre à chaque tracé, et le bon moment pour transmettre ou alerter.',
  },
  {
    icon: '🚑',
    who: 'Infirmier aux urgences, en cardiologie ou en soins critiques',
    situation: 'Les rythmes défilent vite et il faut distinguer un artefact d’une vraie arythmie.',
    benefit: 'Des fiches rythme par rythme, des arbres de décision et des signes d’alerte clairs.',
  },
  {
    icon: '🎓',
    who: 'Étudiant en soins infirmiers (IFSI)',
    situation: 'Entre les cours et les stages, l’ECG reste flou : ondes, intervalles, axe, blocs…',
    benefit: 'Un parcours progressif, des fondamentaux aux cas pédagogiques corrigés.',
  },
  {
    icon: '📖',
    who: 'Étudiant en médecine ou externe',
    situation: 'Vous connaissez la théorie, mais lire un tracé complet avec méthode reste difficile.',
    benefit: 'La méthode FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T, planche par planche.',
  },
  {
    icon: '🏥',
    who: 'Soignant en reprise ou en changement de service',
    situation: 'Vous rejoignez un service avec des patients sous scope et voulez remettre vos repères à jour.',
    benefit: 'Une référence visuelle complète pour réviser vite et surveiller avec assurance.',
  },
]
